module.exports = __webpack_public_path__ + "assets/4ec1861b3564f7f00257012cc4fcc1b2.png";